import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControlOptions,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { ServicoBuscaJudicial } from 'src/app/models/busca-judicial.model';
import { IdentificacaoAtendimento } from 'src/app/models/Servico.model';
import { ServicoService } from 'src/app/services/servico.service';
import { renameDefaultFilenames } from 'src/app/util/rename-default-filenames';
import { ServicoDefaultPage } from '../../../components/servico-default-page';

import { ArquivosManager } from 'src/app/components/arquivos-manager';

@Component({
  selector: 'app-busca-judicial',
  templateUrl: './busca-judicial.component.html',
  styleUrls: ['./busca-judicial.component.css'],
})
export class BuscaJudicialComponent
  extends ServicoDefaultPage
  implements OnInit, OnDestroy
{
  arquivosManager = new ArquivosManager();

  SHOW_FILES_FORM = false;
  pesquisaPorOptions = [
    {
      label: 'Pessoa Física',
      value: 0,
    },
    {
      label: 'Pessoa Jurídica',
      value: 1,
    },
    {
      label: 'CPF/CNPJ Desconhecido',
      value: 2,
    },
  ];

  formSolicitante!: FormGroup;
  formServico!: FormGroup;
  formArquivos!: FormGroup;

  constructor(
    private messageService: MessageService,
    private fb: FormBuilder,
    servicoService: ServicoService,
    router: Router
  ) {
    super(servicoService, router);
  }

  ngOnInit(): void {
    this.getServico('busca-judicial');

    this.formSolicitante = this.fb.group({
      nomeSolicitante: ['', [Validators.required]],
      cpfSolicitante: [
        '',
        [Validators.required, Validators.pattern(/^(\D*\d){11}\D*$/)],
      ],
      emailSolicitante: ['', [Validators.required, Validators.email]],
      declaracaoVeracidade: [null, Validators.required],
      declaracaoAceite: [null, Validators.required],
    });

    this.formServico = this.fb.group(
      {
        buscaJudicialProcesso: [''],
        buscaJudicialOficio: [''],
        pesquisaPor: [this.pesquisaPorOptions[0], Validators.required],
        cpfCnpj: ['', Validators.required],
        nome: [''],
      },
      {
        validators: this.atLeastOneFieldValidator as ValidatorFn,
      } as AbstractControlOptions
    );

    this.formArquivos = this.fb.group({
      informacoes: ['', Validators.required],
    });
  }

  atLeastOneFieldValidator(group: FormGroup): ValidationErrors | null {
    const buscaJudicialProcesso = group.get('buscaJudicialProcesso')?.value;
    const buscaJudicialOficio = group.get('buscaJudicialOficio')?.value;

    return buscaJudicialProcesso || buscaJudicialOficio
      ? null
      : { atLeastOneRequired: true };
  }

  changePesquisaPorHandle(evento: DropdownChangeEvent) {
    if (evento.value.value == 2) {
      this.formServico.removeControl('cpfCnpj');
      this.formServico.get('nome')?.addValidators(Validators.required);
    } else {
      this.formServico.addControl(
        'cpfCnpj',
        new FormControl('', [Validators.required])
      );
      this.formServico.patchValue({ cpfCnpj: '' });
      this.formServico.get('nome')?.removeValidators([Validators.required]);
    }

    this.formServico.get('nome')?.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }

  putDadosSolicitante() {
    this.ACTIVE_INDEX = 1;
    this.formSolicitante.disable();
  }

  handleFormServico() {
    this.SHOW_FILES_FORM = true;
  }

  concluirCadastro() {
    this.loading = true;
    var arquivos = renameDefaultFilenames(this.arquivosManager.anexos);

    let formulario: ServicoBuscaJudicial = {
      ...this.formSolicitante.value,
      ...this.formServico.value,
      ...this.formArquivos.value,
    };

    formulario.pesquisaPor = this.formServico.value['pesquisaPor'].value;

    const formData = new FormData();
    arquivos.forEach((anexo) => {
      formData.append('arquivos', anexo, anexo.name);
    });
    formData.append(
      'formAtendimento',
      new Blob([JSON.stringify(formulario)], { type: 'application/json' })
    );

    this.servicoService.postServicoBuscaJudicial(formData).subscribe({
      next: ({ id, ano, hash }) => {
        this.loading = false;
        this.dadosSolicitacao = new IdentificacaoAtendimento(id, ano, hash);
        this.ACTIVE_INDEX = 2;
      },
      error: (error) => {
        this.loading = false;

        this.messageService.add({
          severity: 'error',
          detail: error.error.message,
        });
      },
    });
  }
}
